// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"47":"8ae3e7f3e805246e95c4","160":"f04bc59012fe3314fe0d","384":"43443a1392f661152830","747":"2c8b9012cc7eb5d75004","894":"1284ad73f126f7f367fb"}[chunkId] + ".js";
};